import PickerContainer from "@pathwright/ui/src/components/picker/PickerContainer"
import withLibraryPicker from "./withLibraryPicker"

export default withLibraryPicker(PickerContainer)
